<template>
  <div id="app" class="full-height">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {}
</script>



// WEBPACK FOOTER //
// App.vue?0d46420f